class IuropSizeGuideLink extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => {
      if (!this.isConnected) return;
      const scope = this.closest('.product-details') || this.closest('dialog');
      const original = scope?.querySelector('button[class*="ai-size-finder-button-"]');
      const trigger = this.querySelector('button');
      if (!original || !trigger) return;
      trigger.textContent = original.getAttribute('aria-label') || original.textContent.trim();
      trigger.onclick = () => original.click();
      original.hidden = true;
      original.parentElement.classList.add('iurop-size-guide-relocated');
      this.hidden = false;
    });
  }
}
if (!customElements.get('iurop-size-guide-link')) customElements.define('iurop-size-guide-link', IuropSizeGuideLink);
